export const UNSAVED_CHANGES_PROMPT =
  "You have unsaved changes. Are you sure you want to leave?";
export const UPDATE = "Update";
export const SUBMIT = "Submit";

export const TAGLINE_INPUT_LABEL = "Tagline: ";
export const TAGLINE_INPUT_PLACEHOLDER = "Go Eagles!";
export const SLUG_INPUT_LABEL = "Slug: ";
export const SLUG_INPUT_PLACEHOLDER = "grcc";
export const LOGO_1_INPUT_LABEL = "Logo #1: ";
export const LOGO_2_INPUT_LABEL = "Logo #2: ";
export const PRIMARY_COLOR_INPUT_LABEL = "Primary Color: ";
export const SECONDARY_COLOR_INPUT_LABEL = "Secondary Color: ";

export const DIRECTORS_HEADING = "Athletic Directors";
export const DIRECTOR_ADD_EMAIL = "Add Email";
export const DIRECTOR_DELETE_TOOLTIP = "Delete";
export const DIRECTOR_EDIT_TOOLTIP = "Edit permissions";

export const TEMPLATES_HEADING = "Templates";
export const TEMPLATES_BODY =
  "Only assign 1 template to a school. Although multiple templates can be added, schools will not be able to know which template they are using.";
export const TEMPLATE_LINK_TOOLTIP = "Link";
export const TEMPLATE_DELETE_TOOLTIP = "Delete";

export const MODAL_TITLE = "Edit permissions";
export const GET_MODAL_SUBTITLE = (email: string) => `Director: ${email}`;
export const MODAL_CHECK_ALL = "check all";
export const MODAL_UNCHECK_ALL = "uncheck all";
export const MODAL_ALLOWED_COACHES = "Viewable coaches";
export const MODAL_CLOSE = "Close";

export const SETTINGS_PAGE_HEADER = "Manage Administrators";
export const ADD_DIRECTOR_INSTRUCTIONS =
  "If you want a colleague (e.g. an assistant or principal) to have the same functionality as you, add their email address below.";


// WEBPACK FOOTER //
// ./src/pages/director/editSchoolUser/constants.ts